import { EmptyState, NoTasksIcon } from '@bp/ui-components';
import { BpCard } from 'components/BpCard/BpCard';
import { TipTapTextExtender } from 'components/TipTap/TipTapTextExtender';
import { useTranslation } from 'react-i18next';

type HomeworkEventProps = {
  uuid: string;
  eventName: string;
  subjectName: string;
  homework: string | null;
  className?: string | undefined;
};

export const HomeworkCard = ({ uuid, eventName, subjectName, homework, className }: HomeworkEventProps) => {
  const { t } = useTranslation();

  return (
    <BpCard
      alwaysCollapsible
      header={{
        headline: subjectName,
        subHeadline: eventName,
        showSubHeadlineAsChip: true,
      }}
      className={className}
    >
      {!homework ? (
        <EmptyState size='small' title={t('homeworks.noHomework')} icon={<NoTasksIcon />} padding='m' />
      ) : (
        <TipTapTextExtender uuid={uuid} content={homework} padding='none' className='mt-4' />
      )}
    </BpCard>
  );
};
